var _path, _rect, _rect2, _rect3, _path2, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotebookReference(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notebook--reference",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11790",
    "data-name": "Path 11790",
    d: "M3.5,20v1.5H6.189L2,25.69l1.061,1.06L7.25,22.56v2.69h1.5V20Z",
    transform: "translate(-0.5 -5)",
    fill: "#ff9200"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5209",
    "data-name": "Rectangle 5209",
    width: 5.25,
    height: 1.5,
    transform: "translate(14.25 7.5)",
    fill: "#ff9200"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5210",
    "data-name": "Rectangle 5210",
    width: 5.25,
    height: 1.5,
    transform: "translate(14.25 11.25)",
    fill: "#ff9200"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5211",
    "data-name": "Rectangle 5211",
    width: 5.25,
    height: 1.5,
    transform: "translate(14.25 15)",
    fill: "#ff9200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11791",
    "data-name": "Path 11791",
    d: "M21.5,5H3.5A1.5,1.5,0,0,0,2,6.5V14H3.5V6.5h8.25v15H21.5A1.5,1.5,0,0,0,23,20V6.5A1.5,1.5,0,0,0,21.5,5ZM13.25,20V6.5H21.5V20Z",
    transform: "translate(-0.5 -1.25)",
    fill: "#ff9200"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebookReference);
export default __webpack_public_path__ + "static/media/notebook-reference.a6dc948811490a6ed0343f93bebb8be7.svg";
export { ForwardRef as ReactComponent };